import { useState } from 'react';

import { BrandMark } from '../../../app/shell/BrandMark.jsx';
import { useSession } from '../hooks/use-session.js';
import { CredentialsForm } from './CredentialsForm.jsx';

/**
 * Shown instead of the sign-up form while new accounts are closed.
 *
 * Sign-up itself is untouched underneath this - `CredentialsForm` still supports
 * `mode="sign-up"` - so re-opening it later is switching this back to that, not
 * rebuilding it.
 */
function SignUpComingSoon({ onBack }) {
  return (
    <div className="auth-form">
      <h1 className="disp auth-form__title">Create your account</h1>
      <p className="auth-form__subtitle">New accounts aren't open yet. Check back soon.</p>
      <div className="auth-coming-soon">
        <span>Coming soon, from the EAX Media team.</span>
        <img className="auth-coming-soon__mark" src="/eax-media-brand.webp" alt="EAX Media" />
      </div>
      <button type="button" className="auth-form__switch" onClick={onBack}>
        Back to sign in
      </button>
    </div>
  );
}

/**
 * The screen shown when nobody is signed in.
 *
 * Sign in and sign up are one screen with a mode, so the brand block, the layout and
 * the failure handling exist once. The old app had a login page, a splash screen and a
 * four-step wizard in one 394 line file, plus three duplicated CSS resets between them.
 *
 * Audit references prevented here: auth.jsx #11, auth.jsx #12, auth.jsx #17.
 */
export function AuthScreen() {
  const { signIn, error } = useSession();
  const [mode, setMode] = useState('sign-in');

  return (
    <div className="auth-screen">
      <div className="auth-screen__card card animate-rise-in">
        <div className="auth-screen__brand">
          <BrandMark />
        </div>

        {error ? (
          <p className="auth-form__failure" role="alert">
            {error}
          </p>
        ) : null}

        {mode === 'sign-up' ? (
          <SignUpComingSoon onBack={() => setMode('sign-in')} />
        ) : (
          <CredentialsForm mode="sign-in" onSubmit={signIn} onSwitchMode={() => setMode('sign-up')} />
        )}
      </div>
    </div>
  );
}
